export default __webpack_public_path__ + "static/media/logo.e995c4ce.png";